<template>
  <nav v-if="tags.length" class="tag-nav" aria-label="Blog topics">
    <ul>
      <li>
        <nuxt-link
          to="/blog"
          class="tag-nav__pill"
          :class="{ 'is-current': !activeSlug }"
          :aria-current="!activeSlug ? 'page' : false"
        >
          All
        </nuxt-link>
      </li>
      <li v-for="tag in tags" :key="tag.slug">
        <nuxt-link
          :to="tagPath(tag.slug)"
          class="tag-nav__pill"
          :class="{ 'is-current': tag.slug === activeSlug }"
          :aria-current="tag.slug === activeSlug ? 'page' : false"
        >
          {{ tag.name }}
          <span class="tag-nav__count">{{ tag.count }}</span>
        </nuxt-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { blogTagPath } from '@/helpers/blog-pagination'

export default {
  name: 'BlogTagNav',
  props: {
    tags: { type: Array, default: () => [] },
    // Slug of the hub currently being viewed, if any.
    activeSlug: { type: String, default: '' },
  },
  methods: {
    tagPath(slug) {
      return blogTagPath(slug)
    },
  },
}
</script>

<style lang="scss" scoped>
.tag-nav {
  margin: 0 0 32px;

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
}

.tag-nav__pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  // Pills sit below the 44px control height on purpose - they are a dense
  // secondary nav, not a primary control - but stay comfortably tappable.
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid var(--ps-border);
  border-radius: var(--ps-radius-pill);
  background: var(--ps-white);
  color: var(--ps-body);
  font-size: var(--ps-text-small);
  font-weight: 600;
  text-decoration: none;
  transition: background-color var(--ps-transition),
    border-color var(--ps-transition), color var(--ps-transition);

  &:hover {
    border-color: var(--ps-indigo-200);
    color: var(--ps-indigo);
  }

  &:focus-visible {
    outline: none;
    border-color: var(--ps-indigo);
    box-shadow: var(--ps-focus-ring);
  }
}

// Indigo: navigating the blog is an in-app action, never a conversion CTA.
.tag-nav__pill.is-current {
  background: var(--ps-indigo);
  border-color: var(--ps-indigo);
  color: var(--ps-white);

  .tag-nav__count {
    color: var(--ps-white);
    opacity: 0.75;
  }
}

.tag-nav__count {
  font-size: var(--ps-text-label);
  font-weight: 500;
  color: var(--ps-muted);
}
</style>
